class SpektrixIframe {
    constructor(element) {
        this.element = element;
        this.iframe = element.querySelector("iframe");

        if (!this.iframe) return;

        this.uid = this.iframe.dataset?.iframeUid;
        this.loadingIndicator = element.querySelector(
            ".spektrix-iframe__loading-indicator",
        );

        this.iframe.addEventListener("load", () => {
            this.loaded();
        });

        if (this.iframe.readyState === "complete") {
            this.loaded();
        }

        window.addEventListener("message", this.receiveMessage.bind(this));
    }

    loaded() {
        this.loadingIndicator &&
            this.loadingIndicator.setAttribute("active", false);
        this.iframe.classList.add("is-loaded");
    }

    receiveMessage(e) {
        if (typeof e.data === "string" && e.data.startsWith("resize:")) {
            const newHeight = Number(e.data.slice(7));
            this.iframe.style.height = newHeight + "px";
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".spektrix-iframe").forEach((element) => {
        new SpektrixIframe(element);
    });
});
